// Lindt Free Gift — попап OptiMonk. Через CartService.addItem с лимитом:
// событие может сработать не раз, подарок в корзине всегда один.
document.addEventListener("optimonk:popup-filled:free-gift", () => {
  if (!window.CartService) return;
  window.CartService.addItem({ variantId: 52055948394824, quantity: 1, maxInCart: 1 })
    .then(() => {
      location.href = "https://myflowers.co.uk/discount/CHOCO";
    })
    .catch((error) => console.error('Lindt free gift: add to cart failed', error));
});
